<h1>Lista de Presupuestos</h1>
<div class="table-overflow-450">
  <table mat-table ngDefaultControl [(ngModel)]="dataSourceFilters" [dataSource]="dataSourceFilters" matSort
    matSortActive="creationDate" matSortDirection="desc" matSortDisableClear class="mat-elevation-z8">
    <ng-container matColumnDef="creationDate">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Fecha Creación </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.creationDate | date: 'dd/MM/yyyy':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="typeBudget">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Tipo Presupuesto </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.typeBudget}} </td>
    </ng-container>
    <ng-container matColumnDef="companyBudget">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Empresa </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.companyBudget}} </td>
    </ng-container>
    <ng-container matColumnDef="titleWork">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Obra </th>
      <td mat-cell *matCellDef="let element"> {{element.titleWork}} </td>
    </ng-container>
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Ubicación </th>
      <td mat-cell *matCellDef="let element"> {{element.location}} </td>
    </ng-container>
    <ng-container matColumnDef="contractor">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Contratante </th>
      <td mat-cell *matCellDef="let element"> {{element.contractor}} </td>
    </ng-container>
    <ng-container matColumnDef="lineItemNumber">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> N° de Partidas </th>
      <td mat-cell *matCellDef="let element" align="right"> {{element.lineItemNumber}} </td>
    </ng-container>
    <ng-container matColumnDef="grandTotal">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Total General </th>
      <td mat-cell *matCellDef="let element" align="right"> {{element.grandTotal | number:'1.2-2':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Acciones </th>
      <td mat-cell *matCellDef="let element">
        <mat-nav-list class="center-flex">
          <button mat-icon-button>
            <mat-icon color="primary" matTooltip="Ver Presupuesto"
              (click)="navigateDetallePresupuesto(element)">file_open</mat-icon>
          </button>
          <button mat-icon-button>
            <mat-icon color="warn" matTooltip="Borrar Presupuesto"
              (click)="deleteBudget(element.idBudget)">delete</mat-icon>
          </button>
        </mat-nav-list>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-medium"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="9">No hay data que filtrar</td>
    </tr>
  </table>
  <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
    class="divconten-button-listpresup">
    <div fxLayout="column">
      <button mat-raised-button class="buttons-text-center" color="warn" type="button" (click)="navigateHomeLineItem()">
        <span class="text-icon-space">Regresar</span>
        <mat-icon>restart_alt</mat-icon>
      </button>
    </div>
  </div>
</div>